import React, { useState } from 'react';
import { useSelector } from "react-redux";
import './Vendorsads.css';
import defaultpicture from '../../../images/banner-1.png';
import { capitalizeWords } from '../../../Utils/LetterCase';
function Vendorsads() {
    const { data } = useSelector((state) => state.fetchProfileData);

    const [images, setImages] = useState({
        banner2: null,
        banner3: null,
    });

    const handleImageChange = (event, bannerKey) => {
        const file = event.target.files[0];
        if (file) {
            setImages((prevImages) => ({
                ...prevImages,
                [bannerKey]: URL.createObjectURL(file),
            }));
        }
    };

    return (
        <div className="community-section">
            <div className="community-inner-wrapper d-flex align-items-center justify-content-between">
                <div className="add-new-community d-flex justify-content-between align-items-center mb-0">
                    <div className="community-heading">Advertisements</div>
                </div>
                <div className='category-block'>
                    <b>Category: {capitalizeWords(data?.data?.sub_vendor_type)}</b>
                </div>
            </div>
            <div className="all-commmunities-table">
                {/* <div className='billing-title allcommunities'>
                    Client Search
                </div> */}
                {/* <div className='input-search mt-2'>
                    <input type="text" placeholder="Start Typing here..." />
                </div> */}
                <div>
                    <div className='billing-title allcommunities ps-0'>
                        Let's get started
                    </div>
                    <p className='mb-0 ads-info'>First, we need to set up your default banner <b>(1600x400 pixels)</b>, which will appear across all your cities unless you choose a custom banner. You can create unique banners for each city and update them anytime you like under Subscriptions.
                    </p>
                </div>
                <div className='banner-upload-block mt-5'>
                    <div className='banner-inner-boxes'>
                        <div className='billing-title allcommunities ps-0 banner-titles'>
                            Default
                        </div>
                        <div className='banner-ad-picture'>
                            <img src={defaultpicture} alt="default-img"></img>
                        </div>
                    </div>
                    <div className='banner-inner-boxes mt-3'>
                        <div className='billing-title allcommunities ps-0 banner-titles'>
                            Banner 2
                        </div>
                        <div className="upload-box">
                            {images.banner2 ? (
                                <img src={images.banner2} alt="Uploaded Preview" className="uploaded-image" />
                            ) : (
                                <label htmlFor="fileInputt" className="upload-btn">
                                    Upload Image
                                </label>
                            )}
                            <input
                                type="file"
                                id="fileInputt"
                                accept="image/*"
                                onChange={(event) => handleImageChange(event, "banner2")}
                                style={{ display: "none" }}
                            />
                        </div>
                    </div>
                    <div className='banner-inner-boxes mt-3'>
                        <div className='billing-title allcommunities ps-0 banner-titles'>
                            Banner 3
                        </div>
                        <div className="upload-box">
                            {images.banner3 ? (
                                <img src={images.banner3} alt="Uploaded Preview" className="uploaded-image" />
                            ) : (
                                <label htmlFor="fileInput" className="upload-btn">
                                    Upload Image
                                </label>
                            )}
                            <input
                                type="file"
                                id="fileInput"
                                accept="image/*"
                                onChange={(event) => handleImageChange(event, "banner3")}
                                style={{ display: "none" }}
                            />
                        </div>
                    </div>
                    <div className='add-banner mt-4 text-center'>
                        <button className='btn-submit-claim add-btn'>Add Button</button>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default Vendorsads;